import React from 'react';
import NormalPoissonGraph from './NormalPoissonGraph';
import FinancialCalculator from './FinancialCalculator';
import FrequencyModelDisplay from './FrequencyModelDisplay';


function Article({ data }) {
  const { title, date, author, content, images, bespoke } = data;

  // Create a map of image positions for easy lookup
  const imageMap = images.reduce((acc, img) => {
    acc[img.position] = img;
    return acc;
  }, {});

  const bespokeMap = bespoke.reduce((acc, comp) => {
    acc[comp.position] = comp;
    return acc;
  }, {});

  const componentMap = {
    NormalPoissonGraph: NormalPoissonGraph,
    FinancialCalculator: FinancialCalculator,
    FrequencyModelDisplay: FrequencyModelDisplay

  };

  return (
    <article className="bg-white border border-gray-200 rounded-lg p-8 transition-shadow max-w-6xl mx-auto mt-20">
      {/* Article Header */}
      <div className="mb-6">
        <h3 className="text-2xl font-bold text-gray-900 mb-2">{title}</h3>
        <div className="flex gap-4 text-sm text-gray-600">
          <span>{author}</span>
          <span>•</span>
          <span>{date}</span>
        </div>
      </div>

      {/* Article Content with Images */}
      <div className="max-w-none">
        {content.map((paragraph, index) => (
          <React.Fragment key={index}>
            <p className="text-gray-700 leading-relaxed mb-4">
              {paragraph}
            </p>
            
            {/* Insert image if one exists at this position */}
            {imageMap[index + 1] && (
              <figure className="my-6">
                <img 
                  src={imageMap[index + 1].src} 
                  alt={imageMap[index + 1].alt}
                  width={imageMap[index + 1].width ? imageMap[index + 1].width : "auto"}
                  style={{margin: "0px auto"}}
                  // className="w-full rounded-lg"
                />
                {imageMap[index + 1].caption && (
                  <figcaption className="text-sm text-gray-600 text-center mt-2">
                    {imageMap[index + 1].caption}
                  </figcaption>
                )}
              </figure>
            )}

            {bespokeMap[index + 1] && (() => {
              const Comp = componentMap[bespokeMap[index + 1].component];
              return Comp ? <Comp {...bespokeMap[index + 1].props} /> : null;
            })()}

          </React.Fragment>
        ))}
      </div>

      {/* Read More Link */}
      {/* <div className="mt-6 pt-6 border-t border-gray-200">
        <a 
          href={`#article-${title.toLowerCase().replace(/\s+/g, '-')}`} 
          className="text-gray-900 font-medium hover:underline inline-flex items-center"
        >
          Read Full Article →
        </a>
      </div> */}
    </article>
  );
}

export default Article;
